function start() {

    console.log('start loading scene');

    this.state.redirect = false;
}

export {start};
